/* eslint-disable no-param-reassign */
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  planCode: "",
  currency: "",
  planName: "",
  planPrice: 0,
  storageLimit: 0,
  studentLimit: 0,
  subTutorLimit: 0,
  testLimit: null,
};

const planSlice = createSlice({
  name: "plan",
  initialState,
  reducers: {
    setPlan(state, action) {
      state.planCode = action.payload.planCode;
      state.currency = action.payload.currency;
      state.planName = action.payload.planName;
      state.planPrice = action.payload.planPrice;
      state.storageLimit = action.payload.storageLimit;
      state.studentLimit = action.payload.studentLimit;
      state.subTutorLimit = action.payload.subTutorLimit;
      state.testLimit = action.payload.testLimit;
    },
  },
});

export const planSelector = (state) => state.plan;

export const planActions = planSlice.actions;

export default planSlice.reducer;
